'use strict';

var StrategyTemplatesPanelController = function StrategyTemplatesPanelController($scope) {
  $scope.selectedTemplate = null;
  $scope.closeButtonHandler = function () {
    $scope.resetSelectedTemplate();
    $scope.closePanelHandler();
  };
  $scope.changeStrategyListingVisibilityButtonHandler = function () {
    $scope.expandCollapseHandler();
  };
  $scope.selectTemplate = function (strategyTemplate) {
    $scope.selectedTemplate = strategyTemplate;
  };
  $scope.isSelectedTemplate = function (strategyTemplate) {
    return $scope.selectedTemplate !== null && strategyTemplate.id === $scope.selectedTemplate.id;
  };
  $scope.resetSelectedTemplate = function () {
    $scope.selectedTemplate = null;
  };
};
StrategyTemplatesPanelController.$inject = ['$scope'];
module.exports = StrategyTemplatesPanelController;